module.exports = __webpack_public_path__ + "media/images/colorway-f050b55eebd14274386999ccab36bc94.png";